import { PcApiResponse } from '@/api/pc-api/types';
import { Count } from '@/api/pc-api/v1/{authInfoId}/statistics/organizations/requested/count';
import { BizType } from '@/constants/bizType';
import { DatePickerType } from '@/constants/datePicker';
import { PREFIX_PATH } from '@/lib/axios/axiosInterceptor';
import { api } from '@/utils/api';

type Args = {
  bizType?: BizType;
  targetId: string;
  calendarType: DatePickerType.WEEKLY | DatePickerType.MONTHLY | DatePickerType.YEARLY;
  startDate: string;
  endDate: string;
};

export type NewlyContractCount = {
  totalCount: number;
  newCount: number;
  changeRate?: number;
  dailyNewCounts: Count[];
};

export const getNewlyContractCount = (args: Args) => {
  if (!args.bizType) return Promise.resolve(null);
  return api<PcApiResponse<NewlyContractCount>>(
    'get',
    `/pc-api/v1/${PREFIX_PATH}/statistics/organizations/newly-contract/count`,
    args
  );
};
